export enum RegistrationOffer {
	DESIGN = 'design',
	SPEED = 'speed',
	INCREASED_SALES = 'increasedSales',
	MANAGEMENT = 'management',
}
